import { gql } from '@apollo/client';

/**
 * Mutation to update an application
 */
export const EditAppMutation = gql`
  mutation EditApplication($input: UpdateApplicationInput!) {
    resources {
      application {
        updateApplication(input: $input) {
          success
        }
      }
    }
  }
`;

/**
 * Mutation to update a functional area connection to an application
 */
export const UpdateFunctionalAreaConnection = gql`
  mutation UpdateAppFunctionalAreaConnection(
    $input: UpdateFunctionalAreaConnectionInput!
  ) {
    devhub {
      connections {
        functionalArea {
          updateFunctionalAreaConnection(input: $input) {
            message
            success
          }
        }
      }
    }
  }
`;

/**
 * Query to get devices associated with an application
 */
export const GetDevicesQuery = gql`
  query ApplicationDevices(
    $applicationId: Int!
    $pagination: PaginationInput
    $filter: ResourceCatalogDeviceFilter
  ) {
    resources {
      application(applicationId: $applicationId) {
        devicesPaged(pagination: $pagination, filter: $filter) {
          devices {
            tier
            ipAddress
            hostname
            environment
            type
            fqdn
            href
            operationalStatus
            serialNumber
            make
            model
            applicationsPaged {
              applications {
                applicationId
                name
                owner {
                  displayName
                }
              }
            }
            osInfo {
              make
              name
              edition
              release
              version
            }
          }
          totalCount
        }
      }
    }
  }
`;

/**
 * URL for the devices query explorer.
 */
export const applicationDeviceQueryUrl =
  'https://fusion.comcast.net/?explorerURLState=N4IgJg9gxgrgtgUwHYBcQC4QEcYIE4CeABAIIAOZANgJZQCGK1ESAIggG60IDOAFADpIiwogBI6FGvUbMAkmHRFZqAISCRYsnQDm1JAyZJFABR16DcpGRgp1I0QDNqlFPkUAlHhBh4oCAMIMdJQQ2mycfgBizq54dgCURMB2wnhePn7cSSkiElS0Fki8eVKF8orikgUySPKJyUIaImAcXNym2ghgvFq6%2BjUVveY1ADRETi5uYhOx9TlNRC0RPNmNCxqM%2BPPr1GQkYGBp3NzbCwAWENwo%2BoinTciceMyIqHcbBGQIbyIOWGBI32EZzSDkBRAgnzwhWCAGUUAwYCc1uthNx8NRggA5eAAIy2yJRcDoAGsvgT1nAIC1KGCStVDFkGiiFnTpIZ5GDhDcycymhAAO5IfCrXkLMDUbhUOgETF0W7klEAXzByoVfO4ygcEBFouERNJnKI3MNXWoNUNaUoCDoaMN7Hw3EMKu%2Bqt5KAg8Mo-m8rzVrqa-uE-sVIBGIHYdDwGJxVu4GBATKI-BArLKYGTigADGMAPQ50gHIipmpKdONZNDfpOjCJ4TJiAOBxo2wYbNJ5HJmhwM0ZgCMmcz7aDghDiqAA';

/**
 * URL for the cloud account query explorer.
 */
export const applicationCloudAccountQueryUrl =
  'https://fusion.comcast.net/?explorerURLState=N4IgJg9gxgrgtgUwHYBcQC4QEcYIE4CeABAMIA2EMYAglFJagM7VJgBKEZCjAYhHtQAOgsgEsoAQxSiISABQASCcLGTpsgJJh0RDagCEASiLAAOkiKWiebpTxRuJ81avKR4qTPlvVnzdqIlFQ91JC1jMwsXKyQJRGdoy0YUKRhGBMSfEK8tDOiIAHckfCcoxMswUUYRCQIAOTiEPJcAX2arKAoqWnoYJlLyq1EwdpdY%2BLLympQAM344Uatk1PTJxOQAN1E8WURURba1qx2uRgHBomHFy3Gmo5dK6rJahomL625BWUZRACNRMTSRyRd6WGzVb5-AGiFAEXL3aInBCvO6gj4QpA-X5cAAKEjwsPOaIAdKSiLIiABVRglEFoqwzbbJFHXcrPZmNVmJCgAc1ESC5VkO9KIpOJ5IsAHEdjBBET6bdBZZhaCVYM1dENcq8iqWiAADQgDb40QSbHcDAgOmmEBZNQ5EYYIgABiIAHo3URqGAwEQ7X4LPC9S0gA';
